import { useState, useEffect } from "react";
import { useAppContext } from "../../AppProvider/AppProvider";


export function Spinner({active}) {
  const { loading, setLoading, loggedIn, setLoggedIn, user, setUser } = useAppContext();

  const [visible, setVisible] = useState(active || loading);


  useEffect(() => {
    if (loading) {
      setVisible(true);
    } else {
      const timeout = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [loading]);

  if (!visible) return null;

  return (
    <div className="spinner-wrapper">
      <div className="spinner"></div>
    </div>
  );
}
